import { c as _c } from "react/compiler-runtime";
import { Card } from "../ui/card";
import { Skeleton } from "../ui/skeleton";
export const EventCardSkeleton = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap gap-1.5"><Skeleton className="h-5 w-16 rounded-full" /><Skeleton className="h-5.5 w-20 rounded-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-6 w-3/4" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="size-5 shrink-0 rounded-full" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-start gap-3">{t2}<div className="space-y-2"><Skeleton className="h-4 w-32" /><Skeleton className="h-3 w-16" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="size-5 shrink-0 rounded-full" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-start gap-3">{t4}<div className="space-y-2"><Skeleton className="h-4 w-36" /><Skeleton className="h-3 w-24" /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Skeleton className="size-10 shrink-0 rounded-full" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="dark:border-slate-850 border-border flex flex-col justify-center gap-6 border-b bg-[#EEF2F6] p-6 md:col-span-3 md:border-r md:border-b-0 dark:bg-slate-900/40">{t0}<div className="space-y-4">{t1}{t3}{t5}<div className="flex gap-3">{t6}<div className="space-y-2"><Skeleton className="h-4 w-24" /><Skeleton className="h-3 w-32" /></div></div></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-1 flex-col justify-center"><div className="grid grid-cols-[20px_1fr] items-center gap-x-3 gap-y-3"><Skeleton className="size-5 shrink-0 rounded-full" /><Skeleton className="h-4 w-24" /><Skeleton className="size-5 shrink-0 rounded-full" /><Skeleton className="h-4 w-36" /><Skeleton className="size-5 shrink-0 rounded-full" /><Skeleton className="h-4 w-48" /><Skeleton className="size-5 shrink-0 rounded-full" /><Skeleton className="h-4 w-16" /><div /><Skeleton className="h-4 w-28" /><div /><Skeleton className="h-4 w-36" /></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Skeleton className="h-10 w-36 rounded-md" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col items-end space-y-1.5"><Skeleton className="h-8 w-28" /><Skeleton className="h-4 w-32" /></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative"><Card className="relative overflow-hidden p-0"><div className="grid grid-cols-1 md:grid-cols-10">{t7}<div className="bg-card flex flex-col justify-between gap-6 p-6 md:col-span-7 md:flex-row">{t8}<div className="flex min-w-60 flex-col items-end justify-between gap-6 text-right">{t9}{t10}<div className="flex w-full flex-col items-end gap-2"><Skeleton className="h-10 w-full rounded-full sm:w-55" /><Skeleton className="h-9 w-full rounded-full sm:w-55" /></div></div></div></div></Card></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};